import React from "react";
import * as Icon from "react-bootstrap-icons";
import { useState, useRef, Fragment, useEffect } from "react";
import DragUpload from "../chatAiComponents/DragUpload";
import { DebounceInput } from "react-debounce-input";
import { useDispatch, useSelector } from "react-redux";
import { fetchExternalListing, uploadAssetContent, addSelectedAsset, editInlineAssetData, deleteAssets } from "../../redux/actions/chatAiActions";
import Loading from "../assetLibComponents/Loading";
import * as types from "../../constants/ChatAiActionTypes";
import Toast from "../assetLibComponents/shared/Toast";
import { ArrowLeft } from "react-bootstrap-icons/dist";
import { ExclamationTriangleIcon  } from "@heroicons/react/24/outline";
import ChatbotViewer from "./ChatbotViewer";
import { Dialog, Transition, Menu } from '@headlessui/react'
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const ChatAssets = (props) => {
  const assetListingRef = useRef();
  const dispatch = useDispatch();
  const authToken = props.authToken;
  const cancelButtonRef = useRef(null)
  const [selectedBarAssets, setSelectedBarAssets] = useState([]);
  const [open, setOpen] = useState(false);
  const [assetTitle, setAssetTitle] = useState("");
  const [assetDescription, setAssetDescription] = useState("");
  const [assetData, setAssetData] = useState({});
  const [previewData, setPreviewData] = useState({});
  const [paginatedData, setPaginatedData] = useState([]);
  const [counter, setCounter] = useState(1);

  const checkLoading = useSelector((state) => state.chatAi.upload_loading);
  const external_asset_list = useSelector((state) => state.chatAi.external_asset_list);
  const api_call_hider = useSelector((state) => state.chatAi.apiCallHider);
  const internal_asset_list = useSelector((state) => state.chatAi.internal_asset_list);
  const isLoading = useSelector((state) => state.chatAi.loading);
  const upload_loading = useSelector((state) => state.chatAi.upload_loading);
  const [dragZone, setDragZone] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [deleteAssetId, setDeleteAssetId] = useState(null);
  const [searchValue2, setSearchValue2] = useState("");
  const [uploadedData, setUploadedData] = useState("");
  const [currentPage, setCurrentPage] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [showPreviewer, setShowPreviewer] = useState(false);
  const [selectedAssets, setselectedAssets] = useState([]);
  const [show, setShow] = useState(false);
  const [actionType, setActionType] = useState("");
  const string_limit = 30; 
  const total_page = Math.ceil(external_asset_list?.total_count / 10);
  const previewUrl = "";
  const handleClose = () => {
    setSearchValue("");
    setUploadedData("");
    setAssetTitle("");
    setAssetDescription("");
    setShow(false);
    dispatch({ type: types.FETCH_INTERNAL_ASSET_LISTING, payload: null});
  }
  const handleShow = () => setShow(true);
  
  const openDragZone = (value) => {
    setDragZone(value)
  }
  
  const handleShowPreviewer = (data) => {
    setPreviewData(data)
    setShowPreviewer(true);
    setTimeout(() => {
      // keep modal open for supported preview types (pdf, txt, video)
      const videoTypes = ["video", "mp4", "webm", "ogg", "m3u8", "mov", "avi", "mkv"];
      if (data.type !== "txt" && data.type !== "pdf" && !videoTypes.includes((data.type || "").toLowerCase())) {
        setShowPreviewer(false);
      }
    }, 50);
  }
  
  const handleHidePreviewer = (data) => {
    setPreviewData({})
    setShowPreviewer(false);
  }
  
  const add_selection = () => {
    if (selectedAssets?.length > 0) {
      dispatch(addSelectedAsset(authToken, selectedAssets))
      setSearchValue("");
      setActionType("");
      setselectedAssets([])
      handleClose();
    } else {
      Toast("Select atleast 1 asset", "E");
    }
  }
  
  const deleteHandleClose = () => {
    setDeleteModal(false);
    setDeleteAssetId(null);
  };
  
  // const svgUploadColorChange = (value, opacity) => {
  //   return <svg width="16" height="16" viewBox="0 0 16 16" fill={value} xmlns="http://www.w3.org/2000/svg">
  //     <path d="M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V11H2V14H14V11H16V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2ZM7 12V3.85L4.4 6.45L3 5L8 0L13 5L11.6 6.45L9 3.85V12H7Z" fill={value} fill-opacity={opacity} />
  //   </svg>
  // }
  
  const uploadAllAssedData = async () => {
    if (upload_loading !== true) {
      if (assetTitle === "") {
        Toast("Please add asset name.");
      } else if (assetDescription === "") {
        Toast("Please add asset description.");
      } else {
        await dispatch(uploadAssetContent(authToken, assetTitle, assetDescription, assetData));
        setCurrentPage("list");
        setActionType("input");
        setCounter(1);
        handleClose();
      }
    }
  }
  
  useEffect(() => {
    assetListingRef.current.addEventListener('scroll', handleScroll);
    return () => {
      if (assetListingRef?.current) {
        assetListingRef.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  
  const handleScroll = async () => {
    const { scrollTop, clientHeight, scrollHeight } = assetListingRef.current;
    if ((scrollTop + clientHeight) >= scrollHeight-1) {
      setCounter((prevPage) => prevPage + 1);
    }
  };
  
  useEffect(() => {
    if (counter <= total_page && counter !== 1) {
      callPaginationApi();
    }
  }, [counter])
  
  const callPaginationApi = async () => {
      await dispatch(fetchExternalListing(props.authToken, "", counter, api_call_hider));
  }
  
  useEffect(() => {
      dispatch(fetchExternalListing(authToken, "", 1,api_call_hider));
  }, [])
  
  useEffect(() => {
    if (counter > 1) {
      setPaginatedData((prevData) => [...prevData, ...external_asset_list.trained_url]);
    } else {
      setPaginatedData(external_asset_list?.trained_url);
    }
  }, [external_asset_list]);
  
  
  const handleCheckboxChange = (obj) => {
    if (selectedAssets.includes(obj)) {
      setselectedAssets(selectedAssets.filter(item => item !== obj));
    } else {
      setselectedAssets([...selectedAssets, obj]);
    }
  };
  
  const onLoad = (fileString,file) => {
    let doc_url
    doc_url = {
      base64: fileString,
      file: {
          name: file.name,
          size: file.size,
          type: file.type
      }
    }
    setAssetData(doc_url);
  };

  const getBase64 = file => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      onLoad(reader.result,file);
    };
  };
  
  const handleSearchPopupOpen = (e) => {
    setSearchValue(e.target.value);
    handleShow();
    setActionType("input");
    setCurrentPage("list");
  }
  
  const handleRemoveSearch2 = (e) => {
    setSearchValue2("");
    dispatch(fetchExternalListing(authToken, "", 1));
  }
  
  const removeFile = () => {
    setUploadedData("");
    setAssetData({});
    setCurrentPage("upload");
  }
  
  const handleUpload = (e) => {
    let extension;
    extension = e.target?.files[0]?.name.toLowerCase();
    if (extension.includes(".doc") || extension.includes(".docx") || extension.includes(".odt") || extension.includes(".pdf")) {
      setUploadedData(e.target.files[0]?.name);
      const files = e.target.files;
      const file = files[0];
      getBase64(file);
      setCurrentPage("addDetails");
    } else {
      Toast("Only pdf and document are allowed", "E");
    }
  };
  
  const handleSearch2 = (e) => {
    if (e.target.value !== undefined) {
      setSearchValue2(e.target.value);
      dispatch(fetchExternalListing(authToken, e.target.value,1));
      setCounter(1);
    }
  }
  
  const handleAssetCheckboxChange = (e,obj) => {
    if (e.target.id !== "anchor_heading") {
      if (selectedBarAssets.includes(obj)) {
        setSelectedBarAssets(selectedBarAssets.filter(item => item !== obj));
      } else {
        setSelectedBarAssets([...selectedBarAssets, obj]);
      }
    }
  };
  
  const handleUrlSelectAll = () => {
    setSelectedBarAssets(paginatedData)
  }
  
  const handleUrlUnSelectAll = () => {
    setSelectedBarAssets([])
  }
  
  const resetCounter = () => {
    setCounter(1);
  }
  
  const multipleDelete = (crawlUrlDelete, pass) => {
    setDeleteModal(true);
    handleDelete(crawlUrlDelete, pass);
  }

  const handleDelete = (did, type) => {
    setDeleteModal(true)
    if (type === "asset_single") {
      setDeleteAssetId({ id: did, type: type });
    } else {
      setDeleteAssetId({ id: null, type: type });
    }
  };
  
  const openEditMode = (itemId,itemTitle) => {
    const updatedListData = paginatedData.map(item => {
      if (item.id === itemId) {
        return { ...item, editing: true, value: itemTitle };
      }
      return { ...item, editing: false };
    });
    setPaginatedData(updatedListData);
  };
  
  const handleInputChange = (event, itemId) => {
    const updatedListData = paginatedData.map(item => {
      if (item.id === itemId) {
        return { ...item, value: event.target.value };
      }
      return item;
    });

    setPaginatedData(updatedListData);
  };
  
  const saveAssetTitle = async (data) => {
    await dispatch(editInlineAssetData(authToken, data)); 
    setCounter(1);
  }
  
  const closeAll = () => {
    const updatedListData = paginatedData.map(item => {
      return { ...item, editing: false };
    });
    setPaginatedData(updatedListData);
  }
    
  const chatOpenHandle = (value) => {
    setOpen(value);
  }

  return (
    <>
      {(isLoading) && <Loading />}
      <div>
        {/* Heading with Button */}
      <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
          <div className="text-lg leading-7 font-[500] my-auto">Assets</div>
          <button
            onClick={()=>{setOpen(true)}}
            type="button"
            className="inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
           >
           <ArrowLeft className="-ml-0.5 h-5 w-5" aria-hidden="true" />
            Test ChatAI
          </button>     
      </div>
        {/* Input Field with Drag and drop Button */}
        <div className="w-full flex my-6 mx-auto">
          <div className="flex relative w-full">
            <DragUpload authToken={ authToken } resetCounter={resetCounter} dragZone={dragZone} openDragZone={openDragZone} />
          </div>
        </div>
        {/* Listing Asset */}
        <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow">
        {/* Listing Heading With Search */}
        <div className="px-4 py-5 sm:px-6 flex justify-between">
          <div className="text-base leading-6 font-semibold my-auto">
             Added Assets
          </div>
          <div className="relative rounded-md shadow-sm my-auto max-sm:w-[50%]">
            <DebounceInput
              value={searchValue}
              className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
              placeholder="Search"
              minLength={3}
              debounceTimeout={500}
              onChange={handleSearch2}
            />
            <div className="absolute z-[9] cursor-pointer right-[5%] top-1/4">
              {searchValue && searchValue !== "" ? (
                  <Icon.X className="h-4 w-4 text-gray-400 pointer" onClick={handleRemoveSearch2} />
                ) : (
                  <Icon.Search className="h-4 w-4 text-gray-400 cursor-pointer" onClick={handleSearch2} />
                )}
            </div>
          </div> 
          </div>
          
         {/* Top Bar */}

        {selectedBarAssets.length > 0 && <div className="flex text-xs max-sm:m-auto items-center justify-between bg-[#F3F4F6]">
          <div className="flex max-sm:flex-col  text-xs max-sm:m-auto items-center w-full max-sm:w-auto justify-between max-sm:px-1 px-4 sm:px-6 max-sm:py-2 py-5 sm:p-1.5 bg-[#F3F4F6] border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)]">
            <div className="max-sm:mb-2">{selectedBarAssets?.length} Selected</div>
            <div className="flex ml-auto mr-0 items-center">
              <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-2 max-sm:ms-1" onClick={() => { multipleDelete(selectedBarAssets, "multiple"); }}>
                    <Icon.Trash3 className="max-sm:hidden"/> <span>Delete</span>
              </div>
              <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-2 max-sm:ms-1" onClick={handleUrlUnSelectAll}>
                    <Icon.Subtract className="max-sm:hidden"/> <span>Unselect All</span>
              </div>
              <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-2 max-sm:ms-1" onClick={handleUrlSelectAll}>
                  <Icon.UiChecks className="max-sm:hidden"/> <span>Select All</span>
              </div>
            </div>
          </div>
        </div>}           
          
        {/* Listing */}
        <div className={(paginatedData?.length > 0 ? "divide-y divide-gray-200 overflow-y-scroll listing ":"flex justify-center items-center ")+(selectedBarAssets.length > 0 ? "xl:h-[30vh] md:h-[31vh] h-[38vh] max-sm:h-[35vh]" : "xl:h-[38vh] md:h-[38vh] h-[30vh] max-sm:h-[41vh]")} ref={assetListingRef}>
        {paginatedData?.length > 0 && paginatedData.map((item,index) => {
          return(
            <div className={item.editing !== true ? "flex justify-between items-center px-4 sm:px-6 py-5 sm:p-4":"flex justify-between px-4 sm:px-6 py-5 sm:py-[7px]"}>
              <div className="listing-check my-auto flex">
                <input
                  type="checkbox"
                  className="me-2"
                  onChange={(e) => handleAssetCheckboxChange(e, item)}
                  checked={selectedBarAssets.includes(item)}
                />
              </div>
              {item.editing !== true ?
                <span title={item?.title} className="text-gray-900 text-sm not-italic font-medium w-[65%] max-sm:w-[50%] inline-block overflow-hidden text-ellipsis whitespace-nowrap ml-2.5">{item?.title}</span>
                  :
                <span className='flex relative items-center pr-2.5 w-[65%] max-sm:w-[50%]'>
                  <input type="text" className="w-full rounded-[5px] ring ring-offset-0 ring-[#cef3fa] pr-[20%] max-sm:pr-[45%] focus:ring focus:ring-offset-0 focus:ring-[#cef3fa]" value={item.value} onChange={(e) => { handleInputChange(e, item.id) }} placeholder="Asset Title" autoFocus />
                  <Icon.Check2 onClick={() => { saveAssetTitle(item) }} className='input-field-svg' />
                  <Icon.X className='input-field-cross-svg' onClick={closeAll} />
                </span>
              }
              <div className="w-[35%] max-sm:w-[50%] flex justify-end items-center">
                {/* {(item.status === "queued" || item.status === "processing") && <span className="animate-pulse inline-flex items-center gap-x-0.5 rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                  Uploading...
                </span>}
                {item.status === "done" && <span className="inline-flex items-center gap-x-0.5 rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                  Done
                </span>}
                {item.status === "queued for deletion" && <span className="animate-pulse inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
                  Removing...
                </span>} */}
                <span className="inline-flex uppercase items-center rounded-md bg-gray-100 ml-4 max-sm:ml-1 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                  {item.type}
                </span>
                <span className="text-[rgba(33,33,33,0.30)] text-xs not-italic font-semibold mx-[25px] max-sm:mx-2 flex items-center cursor-pointer text-[12px] leading-3">
                  {item?.date.slice(0,6)}
                </span>
                <Menu as="div" className="relative inline-block text-left">
                  <div>
                    <Menu.Button className="flex items-center rounded-full text-gray-400 focus:drop-shadow-none	focus:shadow-none focus-visible:drop-shadow-none focus-visible:shadow-none hover:text-gray-600 focus:outline-none focus:ring-0 focus:ring-white-500 focus:ring-offset-0 focus:ring-offset-white-100">
                      <span className="sr-only">Open options</span>
                      <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
                    </Menu.Button>
                  </div>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className={"absolute right-0 z-10 mt-2 w-56 origin-bottom rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"+(index >= paginatedData?.length-3 && index > 2 ? " bottom-[30px]":"")}>
                      <div className="py-1">
                        <Menu.Item>
                          {({ active }) => (
                            <span
                              className={classNames(
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                'block px-4 py-2 text-sm cursor-pointer'
                              )}
                              onClick={()=>{handleShowPreviewer(item)}}
                            >
                              Preview
                            </span>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <span
                              href="#"
                              className={classNames(
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                'block px-4 py-2 text-sm cursor-pointer'
                              )}
                              onClick={()=>{openEditMode(item.id,item.title)}}
                            >
                              Edit
                            </span>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <span
                              href="#"
                              className={classNames(
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                'block px-4 py-2 text-sm cursor-pointer'
                              )}
                              onClick={() => { handleDelete(item.id, "asset_single") }}
                            >
                              Delete
                            </span>
                          )}
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          )
        })}
        {(paginatedData?.length === 0) && (
          <div className="text-[rgba(33,33,33,0.3)] text-[17px] font-[bolder] text-center font-add">
            <span className="flex justify-center text-[40px]">
              <Icon.Inbox />
            </span>
            No Data
          </div>
        )}
        </div>
      </div>

        
      {/* View Mode    */}
      <Transition.Root show={showPreviewer} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleHidePreviewer}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-[#f2f2f2] px-4 pb-4 pt-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:py-4 sm:px-4">
                    <div className={previewData.type !== "txt" ? "bg-[#f2f2f2]":"not-italic font-semibold bg-white rounded-[15px]"}>
                      {previewData ? (
                        (() => {
                          const url = previewData.url || "";
                          const type = (previewData.type || "").toLowerCase();
                          const isPdf = type === "pdf" || /\.pdf(\?|#|$)/i.test(url);
                          const isVideo = type === "video" || /(\.mp4|\.webm|\.ogg|\.m3u8|\.mov|\.avi|\.mkv)(\?|#|$)/i.test(url);
                          if (isPdf) {
                            return (
                              <embed src={url} type="application/pdf" width="100%" height="550px" />
                            );
                          }
                          if (isVideo) {
                            return (
                              <video controls width="100%" height="550">
                                <source src={url} />
                                Your browser does not support the video tag.
                              </video>
                            );
                          }
                          if (type === "txt") {
                            return (
                              <iframe src={url} title="text-preview" className="w-full h-[550px] bg-white rounded-[15px]" />
                            );
                          }
                          return (
                            <p>No preview available</p>
                          );
                        })()
                      ) : (
                        <p>No document to preview</p>
                      )}
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
      </Transition.Root>

      {/* Delete Modal   */}
      <Transition.Root show={deleteModal} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={deleteHandleClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                          <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                        </div>
                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                          <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                            Delete Asset(s)
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                               Are you sure you want to delete the selected Asset(s)?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                        onClick={async () => {
                          const arrayOfIds = await selectedBarAssets.map(obj => obj.id);
                          await dispatch(deleteAssets(authToken, deleteAssetId.type === "asset_single" ? deleteAssetId.id : arrayOfIds , deleteAssetId.type ))
                          setCounter(1);
                          setSelectedBarAssets([]);
                          deleteHandleClose();
                        }}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                        onClick={() => deleteHandleClose(false)}
                        ref={cancelButtonRef}
                      >
                        No
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        <ChatbotViewer authToken={props.authToken} open={open} chatOpenHandle={chatOpenHandle} autoQuestion="" />
      </div>
    </>
  );
};

export default ChatAssets;
